import React from "react";
import { MCheckbox, MInput, MSelect, ValidatedForm } from "components/forms";
import { dateHelper, payloadBuilder } from "libs";
import dayjs from "dayjs";
import axios from "axios";

export class TitoliProfessionali extends ValidatedForm {
  PAYLOADS = {
    competitionClass: [{ label: "Seleziona classe di concorso", value: "-1" }],
    grade: [
      { label: "Seleziona grado", value: "" },
      { label: "Secondaria di I Grado", value: "Secondaria di I Grado" },
      { label: "Secondaria di II Grado", value: "Secondaria di II Grado" },
    ],
  };

  onChangeCheck = (id, value) => {
    if (value === true) {
      this.setState({
        currentFieldSet: this.FIELDS_GROUP_SHORT,
        currentLode: true,
      });
    } else {
      this.setState({
        currentFieldSet: this.FIELDS_GROUP_FULL,
        currentLode: false,
      });
    }
  };

  isTitle14 = () => this.props.template === "Title14Item_TITOLARE_CONTRATTO";

  FIELDS_GROUP_FULL = [
    [
      {
        id: "istitution" + this.props.idx,
        field: "istitution",
        label: "Istituzione Scolastica",
        component: MInput,
        className: "col-md-9 pt-3",
      },
      {
        id: "aa" + this.props.idx,
        field: "aa",
        label: "Anno Scolastico",
        component: MInput,
        className: "col-md-3 pt-3",
        infoText: this.props.checkAA
          ? `inserire formato AAAA/AAAA ${this.isTitle14() ? "(solo anni dal 2020/2021 al 2024/2025)" : "(solo anni fino al 2024/2025)"}`
          : "inserire formato AAAA/AAAA",
      },
    ],
    [
      {
        id: "grado" + this.props.idx,
        field: "grado",
        label: "Grado/ordine di svolgimento del servizio",
        payload: { options: this.PAYLOADS.grade },
        component: MSelect,
        onChange: (_, value) => {
          this.onChangeGrade(_, value, true);
        },
        className: "col-md-6",
      },
      {
        id: "classeConcorso" + this.props.idx,
        field: "classeConcorso",
        label: "Classe di Concorso",
        payload: { options: this.PAYLOADS.competitionClass },
        component: MSelect,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "ufficioScolastico" + this.props.idx,
        field: "ufficioScolastico",
        label: "Codice meccanografico istituto",
        component: MInput,
        className: "col-md-6",
      },
      {
        id: "contactEmail" + this.props.idx,
        field: "contactEmail",
        label: "E-mail dell’istituto",
        component: MInput,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "city" + this.props.idx,
        field: "city",
        label: "Comune",
        component: MInput,
        className: "col-md-10",
      },
      {
        id: "province" + this.props.idx,
        field: "province",
        label: "Provincia (sigla)",
        component: MInput,
        className: "col-md-2",
      },
      {
        id: "address" + this.props.idx,
        field: "address",
        label: "Via/Piazza",
        component: MInput,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dateFrom" + this.props.idx,
        field: "dateFrom",
        label: "dal",
        component: MInput,
        type: "date",
        className: "col-md-4",
      },
      {
        id: "dateTo" + this.props.idx,
        field: "dateTo",
        label: "al",
        component: MInput,
        type: "date",
        className: "col-md-4",
      },
      {
        id: "durata" + this.props.idx,
        field: "durata",
        label: "Per un totale di giorni",
        component: MInput,
        type: "text",
        className: "col-md-4",
      },
    ],
    [
      {
        id: "lode" + this.props.idx,
        field: "lode",
        label: "Fino al termine delle operazioni di scrutinio finale ai sensi dell'articolo 11, comma 14, della legge n. 124 del 1999",
        component: MCheckbox,
        className: "col-md-12",
        onChange: this.onChangeCheck,
      },
    ],
  ];

  FIELDS_GROUP_SHORT = [
    [
      {
        id: "istitution" + this.props.idx,
        field: "istitution",
        label: "Istituzione Scolastica",
        component: MInput,
        className: "col-md-9 pt-3",
      },
      {
        id: "aa" + this.props.idx,
        field: "aa",
        label: "Anno Scolastico",
        component: MInput,
        className: "col-md-3 pt-3",
        infoText: this.props.checkAA
          ? `inserire formato AAAA/AAAA ${this.isTitle14() ? "(solo anni dal 2020/2021 al 2024/2025)" : "(solo anni fino al 2024/2025)"}`
          : "inserire formato AAAA/AAAA",
      },
    ],
    [
      {
        id: "grado" + this.props.idx,
        field: "grado",
        label: "Grado/ordine di svolgimento del servizio",
        payload: { options: this.PAYLOADS.grade },
        component: MSelect,
        onChange: (_, value) => this.onChangeGrade(_, value, true),
        className: "col-md-6",
      },
      {
        id: "classeConcorso" + this.props.idx,
        field: "classeConcorso",
        label: "Classe di Concorso",
        payload: { options: this.PAYLOADS.competitionClass },
        component: MSelect,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "ufficioScolastico" + this.props.idx,
        field: "ufficioScolastico",
        label: "Codice meccanografico istituto",
        component: MInput,
        className: "col-md-6",
      },
      {
        id: "contactEmail" + this.props.idx,
        field: "contactEmail",
        label: "E-mail dell’istituto",
        component: MInput,
        className: "col-md-6",
      },
    ],
    [
      {
        id: "city" + this.props.idx,
        field: "city",
        label: "Comune",
        component: MInput,
        className: "col-md-10",
      },
      {
        id: "province" + this.props.idx,
        field: "province",
        label: "Provincia (sigla)",
        component: MInput,
        className: "col-md-2",
      },
      {
        id: "address" + this.props.idx,
        field: "address",
        label: "Via/Piazza",
        component: MInput,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "dateFrom" + this.props.idx,
        field: "dateFrom",
        label: "dal",
        component: MInput,
        type: "date",
        className: "col-md-4",
      },
    ],
    [
      {
        id: "lode" + this.props.idx,
        field: "lode",
        label: "Fino al termine delle operazioni di scrutinio finale ai sensi dell'articolo 11, comma 14, della legge n. 124 del 1999",
        component: MCheckbox,
        className: "col-md-12",
        onChange: this.onChangeCheck,
      },
    ],
  ];

  ERROR_MESSAGES = {
    istitution: "Inserire l'Istituzione universitaria o accademica",
    city: "Inserire l'Istituzione universitaria o accademica",
    aa: this.props.checkAA
      ? `Inserire l'anno scolastico ${this.isTitle14() ? "dal 2020/2021 al 2024/2025" : "fino al 2024/2025"}`
      : "Inserire l'anno scolastico",
    grado: "Inserire il grado/ordine di svolgimento del servizio",
    ufficioScolastico: "Inserire il codice meccanografico dell'istituto",
    classeConcorso: "Inserire la classe di concorso",
    contactEmail: "Inserire l'email dell'istituto",
    province: "Inserire la provincia",
    address: "Inserire l'indirizzo",
    dateFrom: "Inserire la data di inizio",
    dateTo: "Inserire la data di fine",
    durata: "Inserire il numero di giorni oppure numero di giorni non valido",
  };

  validation = {};

  validation_full = {
    istitution: (value) => value !== "",
    city: (value) => value !== "",
    grado: (value) => value !== "",
    ufficioScolastico: (value) => value !== "" && value.length === 10,
    classeConcorso: (value) => this.validateCompetitionClass(value),
    contactEmail: (value) => value !== "",
    province: (value) => value !== "" && value.length < 4,
    address: (value) => value !== "",
    dateFrom: (value) => this.validateDataFrom(value),
    dateTo: (value) => this.validateDataTo(value),
    durata: (value) => this.validateDuration(value),
    aa: (value) => this.validateAA(value),
  };

  validation_short = {
    istitution: (value) => value !== "",
    city: (value) => value !== "",
    grado: (value) => value !== "",
    ufficioScolastico: (value) => value !== "" && value.length === 10,
    classeConcorso: (value) => this.validateCompetitionClass(value),
    contactEmail: (value) => value !== "",
    province: (value) => value !== "" && value.length < 4,
    address: (value) => value !== "",
    dateFrom: (value) => this.validateDataFrom(value),
    aa: (value) => this.validateAA(value),
  };

  normalize = (v) => {
    if (!v) return "";
    if (typeof v === "object" && v.value !== undefined) return v.value;
    return v;
  };

  validateAA = (value) => {
    let aa = /^(\d{4})\/(\d{4})$/.test(value);

    if (!aa) {
      return false;
    } else {
      aa = value.split("/");

      if (parseInt(aa[1]) > new Date().getFullYear()) {
        return false;
      }

      if (parseInt(aa[1]) !== parseInt(aa[0]) + 1) {
        this.setState({ validationError: "Anno scolastico non valido." });
        return false;
      }

      if (this.props.checkAA) {
        const isTitle14 = this.isTitle14();
        const startYear = parseInt(aa[0]);
        const endYear = parseInt(aa[1]);

        //--- reset dello switch "lode" ---
        if (startYear === 2025) {
          this.setState({ lode: { value: false } });
          this.onChangeCheck("lode" + this.props.idx, false);
        }

        //--- verifica solo annualità ammesse ---
        if (isTitle14) {
          //ammessi aa dal 20/21 al 24/25
          if (startYear < 2020 || endYear > 2025) {
            this.setState({ validationError: "Anno scolastico non ammesso." });
            return false;
          }
        } else {
          //ammessi aa solo fino al 24/25
          if (endYear > 2025) {
            this.setState({ validationError: "Anno scolastico non ammesso." });
            return false;
          }
        }
      }

      return true;
    }
  }; //validateAA

  emptyFields = {
    istitution: "",
    city: "",
    grado: "",
    ufficioScolastico: "",
    classeConcorso: "",
    contactEmail: "",
    province: "",
    address: "",
    dateFrom: "",
    dateTo: "",
    durata: "",
    aa: "",
    lode: false,
  };

  constructor(props) {
    super(props);

    const defaultValues =
      props.defaultValues && typeof props.defaultValues === "object" ? { ...this.emptyFields, ...props.defaultValues } : { ...this.emptyFields };

    this.state = {
      PAYLOADS: [],
      myCurrentGrade: 0,
      currentFieldSet: defaultValues.lode ? this.FIELDS_GROUP_SHORT : this.FIELDS_GROUP_FULL,
      currentLode: defaultValues.lode || false,
      validationError: null,
      ...defaultValues,
      defaultValues,
    };

    this.onChange = this.onChange.bind(this);
  }

  validateDataTo = (value) => {
    const v = this.normalize(value);
    if (!v) return false;

    let regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!v.match(regex)) {
      return false;
    }

    const today = new Date();
    const date = new Date(v);

    if (date > today) {
      this.setState({
        validationError: "Deve essere inserita una data valida precedente ad oggi.",
      });
      return false;
    }

    const aa = this.normalize(this.state.aa);
    if (!aa || /^(\d{4})\/(\d{4})$/.test(aa) === false) {
      this.setState({
        validationError: "Deve essere compilato il campo Anno Scolastico.",
      });
      return false;
    }

    const aaSplit = aa.split("/");

    if (date.getFullYear() < parseInt(aaSplit[0]) || date.getFullYear() > parseInt(aaSplit[1])) {
      this.setState({
        validationError: `La data di fine deve essere compresa nell'Anno accademico ${aa}.`,
      });
      return false;
    }

    //--- ---

    const dateFromStr = this.normalize(this.state.dateFrom);
    if (!dateFromStr) {
      return false;
    }
    const dateFrom = new Date(dateFromStr);

    let dateTo = new Date(`${aaSplit[1]}-08-31`);

    //--- guardia valida solo se AA 2024/2025 ---
    /*
    if (aa === "2024/2025") {
      dateTo = new Date(`${aaSplit[1]}-06-30`);
    }*/

    if (date < dateFrom || date > dateTo) {
      this.setState({
        validationError: `La data di fine deve essere compresa tra il ${dateHelper.toITDate(dateFrom)} e il ${dateHelper.toITDate(dateTo)}.`,
      });
      return false;
    }

    return true;
  };

  validateDataFrom = (value) => {
    const v = this.normalize(value);
    if (!v) return false;

    let regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!v.match(regex)) {
      return false;
    }

    const today = new Date();
    const date = new Date(v);

    if (date > today) {
      this.setState({
        validationError: "Deve essere inserita una data valida precedente ad oggi.",
      });
      return false;
    }

    const aa = this.normalize(this.state.aa);
    if (!aa || /^(\d{4})\/(\d{4})$/.test(aa) === false) {
      this.setState({
        validationError: "Deve essere compilato il campo Anno Scolastico.",
      });
      return false;
    }

    const aaSplit = aa.split("/");

    if (date.getFullYear() < parseInt(aaSplit[0])) {
      this.setState({
        validationError: `La data di inizio non può essere precedente al ${aaSplit[0]}.`,
      });
      return false;
    }

    //--- ---

    //--- guardia valida solo se lode=true ---
    if (this.state.lode === true) {
      // per l'ultimo anno non è possibile flaggare la lode
      if (this.state.aa.value === "2025/2026") {
        this.setState({
          validationError: "Per l'anno accademico 25/26 non può essere dichiarato '..fino al termine delle operazioni di scrutinio finale'.",
        });
        return false;
      }

      const firstFebruary = new Date(`${aaSplit[1]}-02-01 `);

      if (date > firstFebruary) {
        this.setState({
          validationError: `La data di inizio deve essere precedente al 1° febbraio ${aaSplit[1]}.`,
        });
        return false;
      }
    } else {
      const dateFrom = new Date(`${aaSplit[0]}-09-01 00:00`);
      const dateTo = new Date(`${aaSplit[1]}-08-31 00:00`);

      if (date < dateFrom || date > dateTo) {
        this.setState({
          validationError: `La data di inizio deve essere compresa tra il 1° settembre ${aaSplit[0]} e il 31 agosto ${aaSplit[1]}.`,
        });
        return false;
      }
    }

    this.setState({ validationError: "" });
    return true;
  };

  validateCompetitionClass = (value) => {
    if (value === "-1" || value === "") {
      return false;
    }

    if (this.props.skipCC) {
      return true;
    }

    if (value === "ADMM" && this.state.myCurrentGrade !== "I GRADO") {
      return false;
    }
    if (value === "ADSS" && this.state.myCurrentGrade !== "II GRADO") {
      return false;
    }

    return true;
  };

  validateDuration = (durata = "") => {
    let d = typeof durata === "object" && durata !== null ? parseInt(durata.value) : parseInt(durata);
    if (!d) {
      return false;
    }

    const dateFrom = this.normalize(this.state.dateFrom);
    const dateTo = this.normalize(this.state.dateTo);
    if (!dateFrom || !dateTo) return false;

    const diffDays = dayjs(dateTo).diff(dayjs(dateFrom), "day");
    if (isNaN(diffDays)) {
      return false;
    }

    return parseInt(diffDays + 1) === d;
  };

  onChangeGrade = async (_, value, resetCC = false) => {
    try {
      const getLocalData = await axios.get("/assets/json/competitionClassAndGrade.json");

      if (getLocalData.data.length > 0) {
        let filterGrade = value;
        if (filterGrade === "Secondaria di I Grado") {
          filterGrade = "I GRADO";
        }
        if (filterGrade === "Secondaria di II Grado") {
          filterGrade = "II GRADO";
        }

        this.PAYLOADS.competitionClass.length = 0;

        getLocalData.data
          .filter((item) => {
            return item.grade === filterGrade;
          })
          .forEach((item) => {
            this.PAYLOADS.competitionClass.push({
              label: item.competitionClass + " - " + item.subject,
              value: item.competitionClass,
            });
          });

        this.PAYLOADS.competitionClass.unshift({
          label: "Seleziona classe di concorso",
          value: "-1",
        });

        const newState = {
          myCurrentGrade: filterGrade,
          PAYLOADS: { competitionClass: this.PAYLOADS.competitionClass },
        };

        if (resetCC) {
          newState.classeConcorso = "-1";
          newState.defaultValues = {
            ...this.state.defaultValues,
            classeConcorso: "-1",
          };
        }

        this.setState(newState);
      }
    } catch (error) {
      this.setState({ error: true });
    }
  }; //onChangeGrade

  onSubmit = () => {
    let isValid = false;
    this.setState({ validationError: "" });
    isValid = this.checkValidation();

    return isValid;
  };

  componentDidMount() {
    //load competitionClass select options
    if (this.props.defaultValues) {
      const { grado } = this.props.defaultValues;
      this.onChangeGrade(null, grado, false);
    }
  }
  //componentDidMount

  getPayload = () => {
    this.payload = payloadBuilder(this.state);
    this.payload.qualificationType = this.props.qualificationType;
    this.payload.qualificationCode = this.props.qualificationCode;
    this.payload.template = this.props.template;

    if (this.state.currentLode) {
      this.payload.lode = true;
      this.payload.template += "Lode";
      this.payload.dateTo = "";
      this.payload.durata = "";
    } else {
      this.payload.lode = false;
    }

    this.payload.extCode = this.props.extCode;

    if (this.state.university) {
      this.payload.uniCode = this.state.university.uniCode;
    }

    return this.payload;
  };

  renderCurrentForm = () => {
    const { defaultValues, currentFieldSet } = this.state;
    this.validation = currentFieldSet === this.FIELDS_GROUP_SHORT ? this.validation_short : this.validation_full;
    const { code } = this.renderFields(currentFieldSet, defaultValues, true);
    return <>{code}</>;
  };

  render() {
    return (
      <>
        {this.renderCurrentForm()}
        {this.state.validationError && <span className="text-danger">{this.state.validationError}</span>}
      </>
    );
  }
}
